import { GetAccountMeResponse } from "api/models";
import { apiClient } from "../utils";

export const getAccountMe = async (): Promise<GetAccountMeResponse> => {
  const { data } = await apiClient.get<{ message: string; data: GetAccountMeResponse }>(
    "account/me"
  );
  return data.data;
};
